






import { Component, Prop, Vue } from 'vue-property-decorator';
import { ItemModelUtil } from '../model-utils/item-model-util';
import { PlaceItem } from '../models/items/place-item-model';
import { GOOGLE_MAPS_API_KEY } from '@/secrets';

@Component({})
export default class StaticItemMap extends Vue {
  @Prop(PlaceItem) public item!: PlaceItem;
  @Prop(Number) size: number;

  get mapImgSrc() {
    return `https://maps.googleapis.com/maps/api/staticmap?&zoom=13&size=${this.size || 150}x${this.size || 150}&maptype=roadmap&markers=color:red%7C${
      this.item.latitude
    },${this.item.longitude}&key=${GOOGLE_MAPS_API_KEY}`;
  }
}
